module.exports = __webpack_public_path__ + "img/adf6b67.svg";